import moment from "moment-timezone";
import { browserTimezone } from "@/lib/helpers.js";

// Update moment locale to start weeks on mon instead of sunday
moment.updateLocale("en", {
  week: {
    dow: 1
  }
});

// NOTE: when using startOf or endOf, the toDate will auto adjust based on the custom timezone
// We should convert to the users actual timezone before using toDate() on these methods.

export const buildCurrentRange = (period) => {
  const start = moment().tz(browserTimezone).startOf(period).toDate();
  const end = moment().tz(browserTimezone).endOf(period).toDate();
  return [start, end];
};

export const buildFutureRange = (period, offset = [1, 1]) => {
  const start = moment()
    .tz(browserTimezone)
    .add(offset[0], period)
    .startOf(period)
    .toDate();
  const end = moment()
    .tz(browserTimezone)
    .add(offset[1], period)
    .endOf(period)
    .toDate();
  return [start, end];
};

export const buildPreviousRange = (period, offset = [1, 1]) => {
  const start = moment()
    .tz(browserTimezone)
    .subtract(offset[1], period)
    .startOf(period)
    .toDate();
  const end = moment()
    .tz(browserTimezone)
    .subtract(offset[0], period)
    .endOf(period)
    .toDate();
  return [start, end];
};

export const offsetWeek = (range) => {
  // add a +1 offset to weeks so they are mon-sun instead of sun-sat
  return range.map((date) =>
    moment(date).tz(browserTimezone).add(1, "day").toDate()
  );
};

export const previousYearRange = (range) => {
  return range.map((date) =>
    moment(date).tz(browserTimezone).subtract(1, "year").toDate()
  );
};

export const isFutureDate = (date) => moment().isBefore(date);
